export default "__VITE_ASSET__DO54zKAZ__"